module.exports = __webpack_public_path__ + "img/amministrazione-easyer.e0edd388.png";